module.exports = __webpack_public_path__ + "static/img/icon_sf_tab_content.f26d36a.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_sf_tab_content.png
// module id = zxty
// module chunks = 1